import type { TypographyOptions } from '@material-ui/core/styles/createTypography'

const fonts = ['"Poppins"', '"sans-serif"']

export const adminThemeTypography = {
  htmlFontSize: 16,
  fontFamily: fonts.join(', '),
  h1: {
    fontWeight: 400,
    fontSize: '6rem',
    lineHeight: '9rem',
  },
  h2: {
    fontWeight: 400,
    fontSize: '3.75rem',
    lineHeight: '5.625rem',
  },
  h3: {
    fontWeight: 400,
    fontSize: '3rem',
    lineHeight: '4.5rem',
  },
  h4: {
    fontWeight: 400,
    fontSize: '2.125rem',
    lineHeight: '3.25rem',
  },
  h5: {
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: '2.25rem',
  },
  h6: {
    fontWeight: 500,
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
  },
  h7: {
    fontWeight: 400,
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
  },
  body1: {
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
  body2: {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  subtitle1: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: '#9E9E9E',
  },
  button: {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    textTransform: 'capitalize',
  },
} satisfies TypographyOptions
